import { LoadableAfterPaint } from '@confluence/loadable';
// eslint-disable-next-line no-restricted-imports
import type { LoadableType } from '@confluence/loadable/src/types.ts';

import type { DateInterface } from './DateComponent.tsx';
import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next';
import type { Color } from '@atlaskit/status/status';
import type { RefAttributes } from 'react';
import type { EmojiComponentProps } from './EmojiComponent.tsx';

export const DateLoader: LoadableType<DateInterface> = LoadableAfterPaint({
	name: 'DateLoader',
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DateComponent" */ './DateComponent.tsx'))
			.DateComponent,
});

export const EmojiLoader: LoadableType<
	Omit<EmojiComponentProps, keyof WithAnalyticsEventsProps> & RefAttributes<any>
> = LoadableAfterPaint({
	name: 'EmojiLoader',
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EmojiComponent" */ './EmojiComponent.tsx'))
			.EmojiComponent,
});

export const MentionLoader: LoadableType<{
	name: any;
	isUserSelf: any;
}> = LoadableAfterPaint({
	name: 'EmojiLoader',
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-MentionComponent" */ './MentionComponent.tsx'))
			.MentionComponent,
});

export const StatusLoader: LoadableType<{
	text: string;
	color: Color;
	isBold: boolean;
}> = LoadableAfterPaint({
	name: 'StatusLoader',
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-StatusComponent" */ './StatusComponent.tsx'))
			.StatusComponent,
});
